export default {"src":"/_next/static/media/compute.41f11ca8.svg","height":32,"width":32};